import React from 'react';
import styled from 'styled-components';
import { useTranslation } from 'react-i18next';
import TaskAltIcon from '@mui/icons-material/TaskAlt';
import MessageArea from '@ui-parts/MessageArea';
import LinkButton from '@ui-parts/LinkButton';
import { PALETTE } from '~/assets/styles/base';
import { ROUTES } from '~/constants/routes';

const MessageAreaWrapper = styled.div`
  max-width: 706px;
  border: 1px solid ${PALETTE.border.frame};
  margin: 58px auto 0;
`;

const StyledTaskAltIcon = styled(TaskAltIcon)`
  color: ${PALETTE.text.primary};
  font-size: 4rem;
`;

const ReapplyCompleted = () => {
  const { t } = useTranslation();

  return (
    <MessageAreaWrapper>
      <MessageArea
        title={t('surveyReapplyCompleted.messageArea.title')}
        message={t('surveyReapplyCompleted.messageArea.message')}
        desc={t('surveyReapplyCompleted.messageArea.desc')}
        button={
          <LinkButton
            label={t('surveyReapplyCompleted.messageArea.linkButton')}
            variant="outlined"
            href={ROUTES.USER.MYPAGE}
          />
        }
      >
        <StyledTaskAltIcon />
      </MessageArea>
    </MessageAreaWrapper>
  );
};

export default ReapplyCompleted;
